import React from 'react';

import { Achievements, Footer, Header, Experience, Education, Projects } from './container';
import { Navbar } from './components';
import './App.scss';

const App = () => {
  return (
    <div className='app'>
    <Navbar />
    <Header />
    <Experience />
    <Projects />
    <Achievements />
    <Education />
    <Footer />
    </div>
  );
}

export default App;